module.exports = __webpack_public_path__ + "img/trader-moni-logo-01.d7d2f4b8.png";